// frontend/src/components/BrandIcon.jsx
// components/BrandIcon.jsx — icône de marque EscapeOS sur-mesure.
//
// Remplace l'emoji 🔐 générique utilisé un peu partout (login, écrans de
// sécurité, en-têtes) par un mark distinctif : un badge dégradé violet→teal
// (les couleurs de marque déjà utilisées ailleurs dans l'app) avec un trou de
// serrure stylisé au centre — lisible comme "sécurité" tout en étant propre
// à EscapeOS plutôt qu'un pictogramme générique de bibliothèque d'emojis.
//
// SVG inline (pas de fichier image) : se redimensionne nettement à toute
// taille (favicon, avatar, logo d'en-tête) sans perte de qualité.
export default function BrandIcon({ size = 40, rounded = true, style }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ flexShrink: 0, ...style }}
      role="img"
      aria-label="EscapeOS"
    >
      <defs>
        <linearGradient id="eos-brand-grad" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop stopColor="#a387fd" />
          <stop offset="1" stopColor="#00d2b4" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="38" height="38" rx={rounded ? 11 : 4} fill="url(#eos-brand-grad)" />
      <circle cx="20" cy="15.5" r="5.5" fill="#0d0d1a" />
      <path d="M17.1 19.5H22.9L25.3 32.2C25.45 32.95 24.87 33.6 24.1 33.6H15.9C15.13 33.6 14.55 32.95 14.7 32.2L17.1 19.5Z" fill="#0d0d1a" />
    </svg>
  );
}
